
    import './styles.scoped.css';
    export default {
  "dimmed": "awsui_dimmed_10ipo_1doif_13",
  "marker": "awsui_marker_10ipo_1doif_65",
  "marker--line": "awsui_marker--line_10ipo_1doif_105",
  "marker--rectangle": "awsui_marker--rectangle_10ipo_1doif_109",
  "marker--hollow-rectangle": "awsui_marker--hollow-rectangle_10ipo_1doif_116",
  "marker--dashed": "awsui_marker--dashed_10ipo_1doif_132",
  "root": "awsui_root_10ipo_1doif_151",
  "value": "awsui_value_10ipo_1doif_183",
  "expandable": "awsui_expandable_10ipo_1doif_187",
  "list-item": "awsui_list-item_10ipo_1doif_191",
  "inner-list-item": "awsui_inner-list-item_10ipo_1doif_192",
  "key-value-pair": "awsui_key-value-pair_10ipo_1doif_197",
  "expandable-section": "awsui_expandable-section_10ipo_1doif_198",
  "key": "awsui_key_10ipo_1doif_197",
  "sub-items": "awsui_sub-items_10ipo_1doif_213",
  "list": "awsui_list_10ipo_1doif_191",
  "compact": "awsui_compact_10ipo_1doif_239",
  "with-sub-items": "awsui_with-sub-items_10ipo_1doif_244",
  "full-width": "awsui_full-width_10ipo_1doif_249"
};
  